import type {
  HeadingWithAccentedText as HeadingWithAccentedTextType,
  Image,
  Link
} from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSLink } from '@swf/cms';
import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import ExternalLink from '../../../../assets/icons/external-link.svg';
import HeadingWithAccentedText from '../HeadingWithAccentedText/HeadingWithAccentedText';

import styles from './StoryTile.scss';

interface Props {
  image?: Image;
  heading: HeadingWithAccentedTextType;
  description?: string;
  link?: Link;
  classes?: {
    image?: string;
    heading?: string;
    description?: string;
  };
}

const StoryTile: React.FC<Props> = ({ image, heading, description, classes, link }) => (
  <div className={styles.root} style={getBackgroundImageStyle(image?.asset?.url)}>
    <CMSLink {...link}>
      <div className={styles.content}>
        <HeadingWithAccentedText
          className={classNames(styles.heading, classes?.heading)}
          {...heading}
        />
        <p className={styles.description}>{description}</p>
      </div>
    </CMSLink>

    <CMSLink {...link}>
      <div className={styles.linkButton}>
        <ExternalLink />
      </div>
    </CMSLink>
  </div>
);

export default StoryTile;
